import { useState, useEffect } from 'react';

import queryString from 'query-string';
import PropTypes from 'prop-types';
import { NavLink as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormControl from '@mui/material/FormControl';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------
NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const location = useLocation();
  const navigate = useNavigate();

  const parsed = queryString.parse(location.search);

  const [platform, setPlatform] = useState(parsed.platform ? parsed.platform : 'web');
  const [user, setUser] = useState(parsed.user ? parsed.user : 'admin');

  useEffect(() => {
    navigate({
      pathname : location.pathname,
      search : queryString.stringify({platform,user})
    });
  }, [platform, user, location.pathname, navigate]);

  return (
    <Box {...other}>
      <Typography variant="body2" style={{margin:'0 auto',width:'80px'}}>Platform</Typography>
      <FormControl style={{display:'flex',flexDirection:'column',alignItems:'center',marginBottom:'10px'}}>
        <ButtonGroup value={platform} style={{width:'140px'}} variant="contained" aria-label="outlined primary button group">
          <Button value="web" color={platform === 'web' ? 'primary' : 'grey'} onClick={() => setPlatform('web')}>Web</Button>
          <Button value="mobile" color={platform === 'mobile' ? 'primary' : 'grey'} onClick={() => setPlatform('mobile')}>Mobile</Button>
        </ButtonGroup>
      </FormControl>
      <Typography variant="body2" style={{margin:'0 auto',width:'110px'}}>User Status</Typography>
      <FormControl style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
        <ButtonGroup value={user} style={{width:'145px'}} variant="contained" aria-label="outlined primary button group">
          <Button variant="contained" value="admin" color={user === 'admin' ? 'primary' : 'grey'} onClick={() => setUser('admin')}>Admin</Button>
          <Button variant="contained" value="basic" color={user === 'basic' ? 'primary' : 'grey'} onClick={() => setUser('basic')}>Basic</Button>
        </ButtonGroup>
      </FormControl>

      <List disablePadding sx={{ p: 1 }}>
        {
          data.map((item) => (
            <NavItem key={item.title} item={item} />
          ))
        }
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
